export default ['brick', 'panel', 'block', 'monolithic', 'wood'];
